/**
 * Trigger: tr_account_transfers_soft_delete
 * Purpose: Update account balances when an account transfer is soft deleted or restored
 * Table: account_transfers
 * Event: UPDATE OF is_deleted
 */
export const TR_ACCOUNT_TRANSFERS_SOFT_DELETE = `
CREATE TRIGGER tr_account_transfers_soft_delete
UPDATE OF is_deleted ON account_transfers
WHEN new.is_deleted <> old.is_deleted
BEGIN
  UPDATE account_balances
  SET transfers_amount = CASE
    WHEN new.is_deleted = 0 THEN transfers_amount - old.amount
    ELSE transfers_amount + old.amount
  END
  WHERE account_id = old.account_out_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET transfers_amount = CASE
    WHEN new.is_deleted = 0 THEN transfers_amount - old.amount
    ELSE transfers_amount + old.amount
  END
  WHERE account_id = old.account_out_id
    AND currency_id = old.currency_id
    AND balance_date = old.transfer_date;

  UPDATE account_balances
  SET transfers_amount = CASE
    WHEN new.is_deleted = 0 THEN transfers_amount + old.amount
    ELSE transfers_amount - old.amount
  END
  WHERE account_id = old.account_in_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET transfers_amount = CASE
    WHEN new.is_deleted = 0 THEN transfers_amount + old.amount
    ELSE transfers_amount - old.amount
  END
  WHERE account_id = old.account_in_id
    AND currency_id = old.currency_id
    AND balance_date = old.transfer_date;

  -- Delete only the specific daily balance records for both accounts if all amounts are zero
  -- (instead of scanning entire table)
  DELETE FROM account_daily_balances
  WHERE account_id IN (old.account_out_id, old.account_in_id)
    AND currency_id = old.currency_id
    AND balance_date = old.transfer_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  -- Delete activity dates for both accounts if no balances exist
  -- Using separate DELETE statements for better index usage
  DELETE FROM account_activity_dates
  WHERE account_id = old.account_out_id
    AND activity_date = old.transfer_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_daily_balances.account_id = old.account_out_id
        AND account_daily_balances.balance_date = old.transfer_date
      LIMIT 1
    );

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_in_id
    AND activity_date = old.transfer_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_daily_balances.account_id = old.account_in_id
        AND account_daily_balances.balance_date = old.transfer_date
      LIMIT 1
    );
END;
`;
